import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const handlingStandardsAdapter = getAdapter();

const handlingStandardsSlice = createSlice({
  name: 'handlingStandards',
  initialState: handlingStandardsAdapter.getInitialState(),
  reducers: {
    setHandlingStandards: (state, { payload: { handlingStandards } }) => {
      handlingStandardsAdapter.setAll(state, handlingStandards);
    },
  },
});

const selectors = handlingStandardsAdapter.getSelectors(({ handlingStandards }) => handlingStandards);

export const getHandlingStandardsIncludingDeleted = (state) => selectors.selectAll(state);

export const getHandlingStandards = (state) => getHandlingStandardsIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setHandlingStandards,
} = handlingStandardsSlice.actions;

export default handlingStandardsSlice.reducer;
